export default {
  focusMoneyBadgeAlt: {
    logo: 'focusMoneyBadgeAlt',
    title: 'smava ist Deutschlands Vergleichsportal für Kredite',
    body: 'FOCUS-MONEY zeichnet uns als Preissieger in der Kategorie Online-Vergleichsportal aus.',
    linkTo:
      'https://www.smava.de/kredit/Berichtsband-Preis-Sieger-2020-Online-Vergleichsportale.pdf'
  },
  guenstigerGehtNicht: {
    logo: 'guenstigerGehtNicht',
    title: 'Garantiert günstiger als alle anderen',
    body: 'Bei uns bekommen Sie garantiert den niedrigsten Preis mit unserer Günster-Geht-Nicht-Garantie.',
    linkTo: 'https://www.smava.de/kredit/guenstiger'
  },
  focusMoneyBadge: {
    logo: 'focusMoneyBadge',
    title: 'Empfohlen von den Besten - unseren Kunden',
    body: 'Unsere Kunden empfehlen uns als Online-Kreditmarktplatz weiter.',
    linkTo: 'https://www.smava.de/Downloads/smava_focus_money.pdf'
  },
  ekomi: {
    logo: 'ekomi',
    title: 'Ausgezeichnete Kundenzufriedenheit',
    body: 'Für unsere Kundenzufriedenheit erhalten wir das eKomi-Siegel Gold.',
    linkTo: 'https://www.ekomi.de/bewertungen-smava-gmbh.html'
  }
}
